import { Fragment, useContext, useState } from "react";
import CDetailLine from "../CDetailLine";
import color from "context/MaterialUITheme/color";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import dollarFormatter from "utils/FormatterDollar";
import { HomeMonitorContext } from "../useHomeMonitorContext";
import useCurrentDuePaymentNumber from "../useCurrentDuePaymentNumber";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import usePayments from "./usePayments";
import useNextPaymentDate from "./nextPaymentDate";

const ScheduledPayments: React.FC = () => {
  const { loan } = useContext(HomeMonitorContext);
  const currentDuePaymentNumber = useCurrentDuePaymentNumber(loan);
  const [seePaymentHistory, setSeePaymentHistory] = useState(false);
  const paymentHistory = usePayments();
  const { overviewInfo } = useNextPaymentDate();

  return (
    <Fragment>
      <Box
        mt={1}
        bgcolor={color.white}
        px={{ xs: 2, md: 6 }}
        pt={{ xs: 4, md: 5 }}
        {...((loan?.loanType === "HELOAN" || paymentHistory?.payments) && {
          pb: { xs: 4, md: 5 },
        })}
        sx={{ borderTopLeftRadius: 33, borderTopRightRadius: 33 }}
      >
        <Typography variant="h5" fontFamily={"Pro Text Semibold"}>
          {loan?.loanType === "HELOC" ? "Estimated" : "NFTYDoor"} Monthly
          Payment of{" "}
          {loan?.loanType === "HELOAN" &&
            loan?.borrowerSteps?.fundingVerification?.amortizationSchedule
              ?.slice(currentDuePaymentNumber, currentDuePaymentNumber + 1)
              .map((item) => {
                return dollarFormatter.format(item.payment);
              })}
          {loan?.loanType === "HELOC" &&
            dollarFormatter.format(
              loan.borrowerSteps?.fundingVerification
                .monthlyPaymentEstimates?.[0].amount ?? 0
            )}
        </Typography>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          flexDirection={{ xs: "column", md: "row" }}
        >
          <Typography
            variant="subtitle1"
            color={color.gray}
            sx={{ opacity: 0.9 }}
          >
            {loan?.loanType === "HELOC" ? (
              "Please see your monthly statement for your actual payment due"
            ) : (
              <>is due on {overviewInfo?.nextPaymentDate}</>
            )}
          </Typography>
        </Box>{" "}
        {overviewInfo?.message && (
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            flexDirection={{ xs: "column", md: "row" }}
          >
            <Typography
              variant="h6"
              color={color.red}
              sx={{ opacity: 1 }}
              fontFamily={"Pro Text Semibold"}
            >
              {overviewInfo?.message}
            </Typography>
          </Box>
        )}
      </Box>

      <Box
        mt={
          loan?.loanType === "HELOAN" || paymentHistory?.payments
            ? 0.5
            : undefined
        }
        bgcolor={color.white}
        px={{ xs: 2, md: 6 }}
        pb={{ xs: 4, md: 5 }}
        {...((loan?.loanType === "HELOAN" || paymentHistory?.payments) && {
          pt: { xs: 4, md: 5 },
        })}
        sx={{ borderBottomLeftRadius: 33, borderBottomRightRadius: 33 }}
      >
        {loan?.loanType === "HELOAN" && (
          <>
            <Typography
              mb={2}
              variant="h6"
              color={color.gray}
              sx={{ opacity: 0.9 }}
            >
              Next Scheduled Payments
            </Typography>
            {/* map data in CDetailLine */}
            {loan?.borrowerSteps?.fundingVerification?.amortizationSchedule
              ?.slice(currentDuePaymentNumber, currentDuePaymentNumber + 3)
              .map((item) => {
                return (
                  <CDetailLine
                    key={item.paymentNumber}
                    firstColumn={moment(
                      loan?.borrowerSteps?.fundingVerification.createdAt
                    )
                      .add(item.paymentNumber + 1, "month")
                      .startOf("month")
                      .format("MM/DD/YYYY")}
                    secondColumn={dollarFormatter.format(item.payment)}
                  />
                );
              })}
          </>
        )}
        <button
          style={{ all: "unset", textDecoration: "none", cursor: "pointer" }}
          onClick={() => setSeePaymentHistory(!seePaymentHistory)}
        >
          {paymentHistory?.payments && (
            <Box display={"flex"} alignItems={"center"} mb={2}>
              <Typography
                variant="h6"
                color={color.purple}
                sx={{ opacity: 0.9 }}
              >
                See payment history
              </Typography>
              {seePaymentHistory ? (
                <KeyboardArrowUp htmlColor="#6767aa" />
              ) : (
                <KeyboardArrowDown htmlColor="#6767aa" />
              )}
            </Box>
          )}
        </button>
        {seePaymentHistory &&
          paymentHistory?.payments?.pageItems.map((item) => {
            return (
              <CDetailLine
                firstColumn={moment(item?.formatedDate)?.format("MM/DD/YYYY")}
                secondColumn={dollarFormatter.format(
                  Number(item.formatedAmount)
                )}
              />
            );
          })}
      </Box>
    </Fragment>
  );
};

export default ScheduledPayments;
